import { render } from "./NewMod.vue?vue&type=template&id=5114422e&scoped=true"
import script from "./NewMod.vue?vue&type=script&lang=js"
export * from "./NewMod.vue?vue&type=script&lang=js"

import "./NewMod.vue?vue&type=style&index=0&id=5114422e&scoped=scoped&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5114422e"]])

export default __exports__